/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ManualNumericInputDto
 */
export interface ManualNumericInputDto {
    /**
     * 
     * @type {number}
     * @memberof ManualNumericInputDto
     */
    inputValue?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualNumericInputDto
     */
    $type?: ManualNumericInputDtoTypeEnum;
}


/**
 * @export
 */
export const ManualNumericInputDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoManualNumericInputDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManualNumericInputDtoTypeEnum = typeof ManualNumericInputDtoTypeEnum[keyof typeof ManualNumericInputDtoTypeEnum];



/**
 * Check if a given object implements the ManualNumericInputDto interface.
 */
export function instanceOfManualNumericInputDto(value?: unknown): value is ManualNumericInputDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManualNumericInputDtoTypeEnum)[0];
}

export function ManualNumericInputDtoFromJSON(json: any): ManualNumericInputDto {
    return ManualNumericInputDtoFromJSONTyped(json, false);
}

export function ManualNumericInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualNumericInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'inputValue': json['inputValue'] == null ? undefined : json['inputValue'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ManualNumericInputDtoToJSON(value?: ManualNumericInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'inputValue': value['inputValue'],
        '$type': value['$type'],
    });
}

